export { default as PhotoAiSolidIcon } from './PhotoAiSolidIcon';
